
<template>
<v-layout flex class="back1">
    <v-card
      class="hidden-sm-and-down"
      permanent
    >
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar ref="divGenres" class="list-default-img" v-show="isPhoto" @click.stop="addPic">
              <img src="https://randomuser.me/api/portraits/men/85.jpg">
              <input type="file" accept="image/jpg,image/png,image/jpeg,image/gif" capture="camera" @change="onFileChange" style="display: none;">
            </v-list-tile-avatar>

            <v-list-tile-content >
              <v-list-tile-title>{{currentUser}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="item.to"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  <UserProfile/>
  </v-layout>  
</template>




<script>

import firebase from 'firebase'
  export default {
    components:{
      UserProfile: () => import('@/components/UserProfile'),
    },
    data () {
      return {
show: false,
imgUrls: [],
urlArr: [],
isPhoto: true,
btnTitle: '',
isModify: false,
previewImg: '',
isPreview: false,
        currentUser: true,
        drawer: true,
        items: [
          { title: 'Home', icon: 'mdi-key', to:'/'},
          { title: 'where are you?', icon: 'mdi-alert-circle', to:'/outlook' },
          { title: 'Account', icon: 'mdi-account-card-details', to:'/videoPlayer' },
          { title: 'logout', icon: 'mdi-arrow-right-box' }

        ],
        right: null
      }
    },
    watch: {
imgUrls: 'toggleAddPic'
},
    created(){
if(firebase.auth().currentUser){
this.isLoggedIn = true;
this.currentUser = firebase.auth().currentUser.email;
}
},
methods: {
toggleAddPic: function () {
let vm = this;
if (vm.imgUrls.length >= 1) {
vm.isPhoto = false;
} else {
vm.isPhoto = true;
}
},
addPic: function (e) {
let els = this.$refs.divGenres.querySelectorAll('input[type=file]')
els[0].click()
return false
},
onFileChange: function (e) {
var files = e.target.files || e.dataTransfer.files;
if (!files.length) return;
this.createImage(files, e);
},
createImage: function (file, e) {
let vm = this;
lrz(file[0], {
width: 480
}).then(function (rst) {
vm.imgUrls.push(rst.base64);
return rst;
}).always(function () {
// 清空文件上传控件的值
e.target.value = null;
});
},
delImage: function (index) {
let vm = this;
vm.$vux.confirm.show({
title: '确定删除该图片?',
onConfirm() {
vm.imgUrls.splice(index, 1);
}
})

},
previewImage: function (url) {
let vm = this;
vm.isPreview = true;
vm.previewImg = url;
},
closePreview: function () {
let vm = this;
vm.isPreview = false;
vm.previewImg = "";
},
saveImage: function () {
let vm = this;
let urlArr = [],
imgUrls = this.imgUrls;

for (let i = 0; i < imgUrls.length; i++) {
if (imgUrls[i].indexOf('file') == -1) {
urlArr.push(imgUrls[i].split(',')[1]);
} else {
urlArr.push(imgUrls[i]);
}
}

//数据传输操作
}
}















  }
</script>

<style scoped>
.back1{
background: rgba(209, 218, 218, 0.719);
width: 100%;

}
.map {
  width: 1000%;
  height: 40%;
}
</style>

